import React, { PureComponent } from 'react';
import VirtualizedSelect from 'react-virtualized-select';

import { Icon } from '../SvgImage';

import InputWrap from './InputWrap';
import { StyledSelectProps, StyledSelectState } from './types';

class StyledSelect extends PureComponent<StyledSelectProps, StyledSelectState> {
  public constructor(props: StyledSelectProps) {
    super(props);
    this.state = { showOptions: false };
  }

  public handleInputChange = (value: string): string => {
    let showOptions = false;

    if (value.trim() !== '') {
      showOptions = true;
    }

    this.setState({ showOptions });
    return value;
  };

  public renderArrow = (): JSX.Element => <Icon image="search" light />;

  public render(): JSX.Element {
    const {
      labelKey,
      valueKey,
      optionHeight,
      children,
      forwardedRef,
      rounded,
      leftPadded,
      size,
      handleOptionsShowing,
      searchable = true,
      ...rest
    } = this.props;

    return (
      <InputWrap
        rounded={rounded}
        leftPadded={leftPadded}
        size={size || '48px'}
        showOptions={this.state.showOptions}
        handleOptionsShowing={handleOptionsShowing}
      >
        <VirtualizedSelect
          ref={forwardedRef}
          labelKey={labelKey}
          valueKey={valueKey}
          optionHeight={optionHeight || 32}
          searchable={searchable}
          arrowRenderer={searchable ? this.renderArrow : undefined}
          onInputChange={this.handleInputChange}
          {...rest}
        />
        {children}
      </InputWrap>
    );
  }
}

export default StyledSelect;
